import './create.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { Tabs, Pane } from '../shared/tabs';

import CreateForm from './components/form';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content admins-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='admins/' className="link">{ props.intl('Return to list of admins') }</Link>
				</div>
				<div className="container__content-title-position">
					<h2 className="title">{ props.intl('Create new admin') }</h2>
				</div>
			</div>
			<div className="container__content-body ">
				<Tabs  selected={props.currentTab} onTabChange={props.changeTab}>
					<Pane label={props.intl('Main')} index="main">
						<CreateForm {...props}/>
					</Pane>
					<Pane label={props.intl('Permissions')} index="permissions" isVisible={false} />
				</Tabs>
			</div>
		</div>
	</Animate>
), 'create');

export default connect(
	state => ({
		data: selectors.getData(state),
		langSelectOptions: selectors.getLangSelectOptions(state),
		adminRoles: selectors.getAdminRoles(state),
		permissionsSelectOptions: selectors.getPermissionsSelectOptions(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		timezoneOptions: selectors.getTimezoneOptions(state),
		error: selectors.getError(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		currentTab: selectors.getCurrentTab(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/create.js